import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary pt-10 pb-10 border-t border-white/5 relative z-10">
      <div className="max-w-6xl mx-auto px-4">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-6 md:gap-8 mb-8">
          {/* Brand */}
          <div className="text-center md:text-left max-w-md">
            <h2 className="text-2xl md:text-xl lg:text-6xl font-bold tracking-widest text-white">
              RAVIANSYAH NOORMAN
            </h2>
            <p className="text-gray-500 text-xs md:text-sm mt-2">
              Building digital experiences with code & creativity.
            </p>
          </div>

          {/* Certifications */}
          <div className="flex flex-col gap-3 text-center md:text-right w-full md:w-auto">
            <span className="text-xs font-mono uppercase tracking-widest text-zinc-500">Certifications</span>
            <div className="flex flex-col gap-4">
              {/* Cisco CCNA */}
              <a
                href="https://www.cisco.com/site/us/en/learn/training-certifications/certifications/enterprise/ccna/index.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <div className="font-mono text-sm">Cisco CCNA</div>
                <div className="text-xs text-zinc-600">Introduction to Networking</div>
              </a>

              {/* Microsoft MCTS */}
              <div className="text-gray-400">
                <div className="font-mono text-sm">MCTS: .NET Framework 4</div>
                <div className="text-xs text-zinc-600">Service Communication Applications</div>
              </div>

              {/* Power BI */}
              <div className="text-gray-400">
                <div className="font-mono text-sm">Power BI: UTHM Data Science Day 2024</div>
                <div className="text-xs text-zinc-600">Data Visualization 101</div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 pt-6 border-t border-white/5">
          {/* Social Links */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-6">
            <a
              href="https://github.com/raaviian"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
            >
              GitHub
            </a>
            <a
              href="https://linkedin.com/in/raaviian/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-400 transition-colors"
            >
              LinkedIn
            </a>
            <a
              href="mailto:raviontv@gmail.com"
              className="text-gray-400 hover:text-accent transition-colors"
            >
              Email
            </a>
          </div>

          {/* Copyright */}
          <div className="text-gray-600 text-xs md:text-sm">
            &copy; {new Date().getFullYear()} Raviansyah Noorman, Made with passion.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
